module.exports = __webpack_public_path__ + "static/media/vha.872ad7fd.png";